import { EnvironmentProviders } from '@angular/core';
import { Route, RouterFeatures, provideRouter, withPreloading, withRouterConfig } from '@angular/router';

import { SpeculativeLinkPreloader } from '@frontend/vanilla/features/speculative-link';

export function provideHostRouter(routes: Route[]): EnvironmentProviders {
    const features: RouterFeatures[] = [
        withPreloading(SpeculativeLinkPreloader),
        withRouterConfig({ urlUpdateStrategy: 'eager' }),
        // disabled for now to investigate myaccount issues
        // withViewTransitions({ skipInitialTransition: true }),
    ];

    return provideRouter(routes, ...features);
}
